module.exports = __webpack_public_path__ + "img/Senegal.ca00f944.svg";